export const en = {
    WelcomeToTicketHub: "Welcome to Ticketize",
    LogInWithGoogle: "Log in with Google",
    SupportTickets: "Support Tickets",
    PleaseSendTicket: "Please submit a ticket",
    AddNewTicket: "Add a ticket",
    LatestSupportTickets: "Latest Support Tickets",
    Select: "Select",
    TicketNumber: " # Ticket",
    TicketName: "TICKET NAME",
    Priority: "PRIORITY",
    PageConcerned: "CONCERNED ELEMENT",
    Status: "STATUT",
    CreatedAt: "CREATED AT",
    Reset: "Reset",
    WriteDescription: "DESCRIPTION OF THE ISSUE",
    TicketType: "TICKET TYPE",
    Cancel: "Cancel",
    Edit: "Edit",
    Delete: "Delete",
    TicketSuccessfullyDeleted: "Ticket successfully deleted",
    ErrorDeletingTicket: "Error when deleting ticket:",
    AreYouSureToDeleteTicket: "Are you sure you want to delete this ticket ?",
    Deleting: "Deleting...",
    TicketActivity: "Ticket activity",
    performedBy: "Done by:",
    NoActivityYet: "No Activity Yet",
    UpdateTicket: "Update Ticket",
    Signout: "Sign Out",
    SuccessfullyLoggedInWithGoogle: "Successfully Logged In With Google",
    Projects: "Projects",
    NoProjectNorma: "No project for the moment ",
    NoTicketsToShow:
      "No tickets to show for this project / No project selected",
    YourColleagues: "Your team members",
    Company: "Company",
    UserProfile: "User's profile",
    YourUserProfil: "Your user profile",
    InviteUser: "Invite a user",
    Confirm: "Confirm",
    PleaseFillYourCompanyName: "Please fill your company name",
    PleaseFillYourCompanyNameFirst: "Fill your company name first",
    CompleteYourProfile: "What is the name of your company?",
    ProfileFormDescription:
      "Thanks to fill out the name of your company, in order to attach your and your collegue to this entity",
    NoColleagues: "No team member for the moment",
    SendInvite: "Send the invite",
    EmailAlreadyExists: "This email has already been used to send an invite",
    JoinedOn: "Joined On",
    TeamMembers: "TEAM MEMBER(S)",
    Pending: "Pending",
    ProjectsList: "PROJECTS LIST",
    AddAProject: "Add a project",
    YouAreSuspended: "Your account has been suspended",
    ContactAdminsAt: "Please contact the admin at",
    AddProject: "Add a project",
    OnboardingTitle: "A few quick questions",
    OnboardingSubtitle: "This helps us improve Ticketize right after launch.",
    OnboardingBack: "Back",
    OnboardingNext: "Continue",
    OnboardingFinish: "Finish",
    OnboardingStepLabel: "Step",
    OnboardingQuestionAcquisition: "How did you find us?",
    OnboardingQuestionUsage:
      "What type of usage will you have for Ticketize?",
    OnboardingQuestionIndustry: "Which industry are you in?",
    OnboardingOptionGoogle: "Google",
    OnboardingOptionChatgpt: "ChatGPT",
    OnboardingOptionReddit: "Reddit or similar",
    OnboardingOptionOther: "Other",
    OnboardingOptionPro: "Professional use",
    OnboardingOptionPersonal: "Personal use",
    OnboardingOptionTech: "Tech / SaaS / Digital agency",
    OnboardingOptionEcommerce:
      "E-commerce / Retail / Online services",
    OnboardingOptionLocal: "Local services / SMB",
    OnboardingOptionOtherIndustry: "Other industry",
    ProjectName: "Project name",
    PageListCategories: "Pages list categories",
    CommaSeparated: "Comma Separated",
    Create: "Create",
    ProjectCreated: "Project created",
    EditProject: "Edit project",
    ProjectMembers: "Project members",
    SelectMembers: "Select member(s)",
    Save: "Save",
    OptionalMessage: "Optional Message",
    Creator: "Created by",
    Project: "PROJECT",
    Type: "TYPE",
    MissingFields: "MISSING FIELDS",
    TicketNameError: "Ticket name",
    WriteDescriptionError: "Ticket description",
    TicketTypeError: "Ticket type",
    RequiredField: "Required field",
    TicketNameForm: "Ticket name",
    PriorityForm: "Priority",
    Incident: "Incident",
    Problem: "Problem",
    Question: "Question",
    Suggestion: "Suggestion",
    Evolution: "Improvement",
    Bug: "Bug",
    Feature: "Feature",
    Improvement: "Improvement",
    ChangeRequest: "Change request",
    Task: "Task",
    Low: "Low",
    Medium: "Medium",
    High: "High",
    AddComment: "Add comment",
    PostComment: "Post comment",
    StatusChangedOpen: "Status  Open",
    StatusChangedClosed: "Status  Closed",
    TicketCreated: "Ticket created",
    AdminComment: "Admin comment",
    PriorityChanged: "Priority changed",
    Open: "Open",
    WorkingOnIt: "Working on it",
    InStaging: "In staging",
    InTest: "In test",
    InProduction: "In production",
    Closed: "Closed",
    UserComment: "User comment",
    InReview: "In review",
    ManageFile: "Manage file(s)",
    UploadFiles: "Upload file(s)",
    DragAndDropOrBrowse: "Drag and Drop or Browse file",
    MaxFileSize: "Max file size : ",
    Done: "Done",
    SaveAttachments: "Save attachments",
    ChooseAProject: "Choose a project",
    NoProjectNormal: "No project for the moment ",
    TryAnotherProjectOrTab: "Select/add a projet on the top or change tab",
    NoTicketsInTab: "No tickets on this status for this project",
    NoTicketsInTabMessage: "Select another tab to see if there is ticket",
    EmailAddress: "Email address",
    InviteByEmail: "Invit a user by email",
    SendAMessage: "Send a message",
    AttachedFiles: "ATTACHED FILES",
    InviteSent: "Invite sent",
    NoProjects: "No project for the moment",
    ExplainationAddProject:
      "Add a project name and project member(s) that you want to attach to this project",
    NoMemberToAdd: "You can add a member (optional).",
    ConfirmLogout: "Confirm log out ?",
    Logout: "Log out",
    InvalidEmail: "Please enter a valid email address",
    EmailAlreadyInvited: "This email has already been invited",
    AlreadyMemberOfACompany: "This user already belongs to a company",
    InviteFailed: "Failed to send invitation",
    RoleUpdated: "Role updated successfully",
    RoleUpdateFailed: "Failed to update role",
    PhotoUploadFailed: "Failed to upload photo",
    UserDeletedSuccessfully: "User deleted successfully",
    UserDeleteFailed: "Failed to delete user",
    ProjectUpdated: "Project updated successfully",
    ProjectDeletedConfirm: "Are you sure you want to delete this project?",
    All: "All",
    AdminNoProjectsYet: "No projects yet",
    NoProjectSelected: "No project selected",
    GetStartedByCreatingProject: "Get started by creating a project",
    TicketAddedSuccessfully: "Ticket added successfully",
    FailedToAddTicket: "Failed to add ticket",
    TicketUpdatedSuccessfully: "Ticket updated successfully",
    FailedToUpdateTicket: "Failed to update ticket",
    OnlyCreatorCanEdit: "Only the creator or an admin can edit this ticket",
    AttachmentsSaved: "Attachments saved",
    SelectProject: "Please select a project",
    MustBeActiveUser: "You must be an active user to perform this action",
    PriorityError: "Priority",
    WhoAreWe: "Who are we?",
    Welcome: "Welcome",
    EditPicture: "Edit Picture",
    DeleteTicket: "Delete Ticket",
    ConfirmDeleteTicket: "Are you sure you want to delete this ticket ?",
    HeroTitlePart1: "The simplest support ticket SaaS",
    HeroTitlePart2: "free for small teams",
    HeroHighlight: "Ticketize",
    HeroTitleFull:
      "Ticketize - The simplest support ticket SaaS, free for small teams",
    HeroMetaDescription:
      "Ticketize is the simplest support ticket SaaS: free for small teams, lowest cost to scale, streamlined workflows, unlimited agents on the $5/mo plan.",
    HeroSubtitle:
      "Centralize requests, assign owners, and resolve faster. Start free; keep unlimited agents at $5/mo.",
    HeroPrimaryCta: "Create my free account",
    HeroPrimaryCtaHelper:
      "Connect with Google and start tracking tickets in minutes.",
    EmailPlaceholder: "Enter your email",
    ButtonDemo: "Request a demo",
    HeroImageAlt: "Ticketize dashboard preview",
    FeatureZeroCost: "Zerocost, adfree core features",
    FeatureEase: "Effortless setup and daily use",
    FeaturePremiumValue: "Premium at $5/mo with AI insights",
    AboutPageTitle: "About Ticketize  Sustainable",
    AboutPageMeta:
      "Discover how Ticketize stays profitable: a generous free plan at $0 cost, and a $5/mo premium that fuels advanced features like email/SMS alerts & AI-driven insights.",
    AboutHeroTitle: "Who We Are",
    AboutHeroSubtitle:
      "At Ticketize, our mission is to empower small businesses with a fullyfledged ticketing systemabsolutely free and adfree.",
    AboutModelTitle: "Our Sustainable Model",
    FreePlanTitle: "Free Plan",
    FreePlanFeature1: "Up to 50 tickets/month  more than enough for most SMEs.",
    FreePlanFeature2: "No banners, no tricksjust a simple, reliable service.",
    PremiumPlanTitle: "Premium Plan",
    PremiumPlanFeature1: "$5/month for unlimited tickets & users.",
    PremiumPlanFeature2: "Email & SMS notifications to keep you in the loop.",
    PremiumPlanFeature3:
      "Weekly AIpowered insights: your top submitted issues analyzed automatically.",
    WhyChooseTitle: "Why Choose Ticketize?",
    WhyChooseFeature1Title: "ZeroCost Starter",
    WhyChooseFeature1Desc:
      "Hundreds of businesses onboarded without spending a dime.",
    WhyChooseFeature2Title: "Scalable Premium",
    WhyChooseFeature2Desc: "Generous $5/month plan that grows with your needs.",
    WhyChooseFeature3Title: "AIDriven Insights",
    WhyChooseFeature3Desc:
      "Automated weekly reports to pinpoint recurring issues.",
    PricingPageTitle:
      "Ticketize Pricing - Free support tickets, $5/mo to scale",
    PricingPageMeta:
      "Free plan for small teams, $5/mo for unlimited tickets, agents, and alerts. Ticketize is the lowest-cost support ticket SaaS.",
    PricingTitle: "Pricing Plans",
    PricingSubtitle: "Start free and upgrade only if you need more power.",
    TierFreeName: "Free",
    TierFreePrice: "0",
    TierFreeFeature1: "Up to 50 tickets/mo",
    TierFreeFeature2: "3 active users",
    TierFreeFeature3: "Inapp notifications",
    TierFreeFeature4: "100Mo attachments",
    TierFreeButton: "Get Started",
    TierPremiumName: "Premium",
    TierPremiumPrice: "5",
    TierPremiumFeature1: "Unlimited tickets & users",
    TierPremiumFeature2: "Email & SMS notifications",
    TierPremiumFeature3: "Weekly AIpowered insights",
    TierPremiumFeature4: "Webhooks & SSO integrations",
    TierPremiumFeature5: "Custom branding & priority support",
    TierPremiumButton: "Upgrade Now",
    Brand: "Ticketize",
    NavOffer: "Our offer",
    Pricing: "Pricing",
    SignIn: "Sign In",
    ComingSoon: "Coming Soon",
    DetailComingSoon: "We are working on it",
    DetailAvailableOnPremium:
      "Unlock detailed insights by upgrading your plan.",
    AvailableOnPremium: "Available on Premium",
    Dashboard: "Dashboard",
    HelpFAQs: "Help & FAQs",
    TicketInsights: "Ticket Insights",
    GoPremium: "Go premium",
    GoToDashboard: "Go to Dashboard",
    YouArePremium: "You are Premium",
    SearchTicketsPlaceholder: "Search tickets (title, description, number)",
    FreePlanProjectLimit: "On the Free plan you can create only 1 project.",
    ProjectLimitReached:
      "Project limit reached. Upgrade to Premium to create more projects.",
    FreePlanTicketLimit:
      "On the Free plan you can create up to 40 tickets per month.",
    TicketLimitReached:
      "Monthly ticket limit reached (40). Upgrade to Premium for unlimited tickets.",
    CurrentMonthTicketsCount: "Tickets created this month: {count}/40.",
    OnlyOneProjectOnFree: "Only 1 project allowed on the Free plan.",
    FortyTicketsPerMonthOnFree:
      "Limit of 40 tickets per calendar month on the Free plan.",
    MyTickets: "My tickets",
    PremiumNeededForMoreProjects:
      "Free plan allows only 1 project. Upgrade to Premium to create more projects.",
    MonthlyTicketCapReached:
      "Youve reached the monthly limit of {limit} tickets on the Free plan. Upgrade to Premium to keep creating tickets.",
    Limit3CollaboratorsNonPremium:
      "Non-premium users can only add up to 3 collaborators per project.",
    Limit3CollaboratorsReachedInvite:
      "Youve reached the free limit of {limit} collaborators. Upgrade to Premium to invite more.",
    OptionalMemberInfo: "You can add a member (optional).",
    DarkModeOn: "Dark Mode On",
    DarkModeOff: "Dark Mode Off",
    ManageSubscription: "Manage subscription",
    // en
    SubscriptionCanceledTitle: "Subscription canceled",
    SubscriptionCanceledMessage:
      "Your subscription has been canceled. You can renew it at any time.",
    RenewSubscription: "Renew subscription",
    AllSubscriptions: "All subscriptions",
    Subscription: "Subscription",
    Customer: "Customer",
    Price: "Price",
    CancelScheduled: "Cancellation scheduled",
    ConfirmCancelSubscription:
      "Are you sure you want to cancel this subscription at the period end?",
    CancelNow: "Cancel at period end",
    PaymentSuccessTitle: "Payment successful",
    PaymentSuccessMessage: "Your Premium subscription is now active.",
    PaymentCanceledTitle: "Payment canceled",
    PaymentCanceledMessage: "The payment was canceled. You can try again.",
    TryAgain: "Try again",
    NewsletterEmailPlaceholder: "Your email",
    NewsletterCta: "Sign up",
    NewsletterSubmitting: "Signing up",
    NewsletterThanks: "Thanks! Youre on the list.",
    NewsletterInvalidEmail: "Please enter a valid email address.",
    NewsletterSaveFailed: "We couldn't save your email. Please try again.",
    ContactUs: "Contact us",
    ClearReadNotifications: "Clear read notifications",
    PrivacyPolicy: "Privacy Policy",
    PrivacyPolicyTitle: "Privacy Policy",
    Close: "Close",
};
